import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../authentication/AuthProvider";
import { routes } from "../routes/routes";
import { findCurrectPermission } from "../helpers/roles-and-permissions";
import { enums } from "../enums/Enums";



export function EvalutionProcessGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(
      enums.UserPermissionNames.FTO_Addvisitor
    ) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}